<template>
  <div class="wrap REFERRAL">
    <div class="header">
      <NavBar
        title="Item"
        left-arrow
        @click-left="$router.go(-1)"
        class="no_bg"
      >
        <span slot="right" icon="cart-o">
          <Popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            @select="onSelect"
          >
            <template #reference>
              <Icon
                name="https://b.yzcdn.cn/vant/icon-demo-1126.png"
                size="0.8rem"
              />
              <!-- <van-button type="primary">浅色风格</van-button> -->
            </template>
          </Popover>
        </span>
      </NavBar>
    </div>
    <div class="main">
      <div class="top">
        <!-- 分享1的页面 未领取验证码得页面-->
        <div v-if="!codes && statusCode == false">
          <div class="topItem topOne" v-if="discount">{{ discount.replace('%','') }}</div>
          <div class="topItem topFont">Your friend sends you a coupon.</div>
          <div class="topItem Fxafter">
            <!-- <p>Expiration Date:{{ 2020 - 12 - 11 }}</p> -->
            <p>Use it to purchase the below product</p>
            <p v-if="discount">with {{ discount }} off before the expire date!</p>
          </div>
          <div class="topItem">
            <Button @click="getYHJ()" plain hairline type="info" class="btn" :class="[codes ? 'yzmaa' : 'yzmbb']"
              >GET CODE</Button
            >
          </div>
        </div>
        <!-- 领取验证码过期的页面 -->
        <div v-if="statusCode">
          <div class="topItem topOne">{{Number(discount) *100}}</div>
          <div class="topItem topFont">Your friend sends you a coupon.</div>
          <div class="topItem Fxafter">
            <!-- <p>Expiration Date:{{ 2020 - 12 - 11 }}</p> -->
            <p>Use it to purchase the below product</p>
            <p>with {{Number(discount) *100}}%  off before the expiration date!</p>
          </div>
          <div class="topItem">
            <Button @click="getYHJ()" plain hairline type="info" class="btn" 
              >Re-apply</Button
            >
          </div>
        </div>
        <!-- 领取验证码后有效期的页面 -->
        <div v-if="codes && statusCode == false">
          <div class="topItem topOne" v-if="discount">{{Number(discount) *100}}</div>
          <div class="topItem topFont">
            <p>Congratuations!</p>
            <p>You've got the coupon code.</p>
          </div>
          <!-- <div class="topItem topFont">
            <span v-if ="codes.data">Coupon Code: {{ codes.data.couponCode }}</span>
            <span @click="Copys" class="copys">Copy</span>
          </div> -->
          <div class="topItem Fxafter">
            <p>Expiration Date:{{endTime}}</p>
            <!-- <p>Expiration Date:{{   toTime(codes.data.endTime)   }}</p> -->
            <p>Use the code at checkout and the price will</p>
            <p v-if="discount">be markdown. Shop Now and Save {{Number(discount) *100}}%!!!</p>
            <p>Hurry Up!</p>
          </div>
          <div class="topItem">
            <Button @click="Copys" plain hairline type="info" class="btn copybtn" 
              >{{ codes.data.couponCode }}   
              <span class="copyBtnText">copy</span></Button
            >
          </div>

        </div>
        <!-- 分享的商品详情 -->
        <div class="FXdetail"  v-if="productEntity" @click="$router.push({ path: '/productItem', query: { id:productEntity.productId } })">
          <div class="fxXX">
            <div class="imgBox">
              <img
                v-if="productEntity.productFileEntity"
                :src="
                  toPicProductImg(productEntity.productFileEntity.mainImg)
                "
                alt=""
              />
            </div>
            <!-- <img src="../../../public/img/REFERRALbg.png" alt=""> -->
            <div class="fxXXR">
              <div class="title">{{ productEntity.productName }}</div>
              <div class="basic">
                {{ productEntity.basicInfo }}
              </div>
              <!-- <div>Coverage : <span>123</span></div> -->
              <!-- <div>Max.Gain : <span>60 dB:</span></div> -->
              <div class="Fxafter">
                <span class="discountPrice" 
                  >${{ productEntity.discountPrice }}</span>
                <span class="nomalPrice" 
                  >${{ productEntity.nomalPrice }}</span
                >
              </div>
              <div v-if="productEntity.avgStar">
                <Rate
                  allow-half
                  readonly
                  v-model="productEntity.avgStar"
                  :size="20"
                />
              </div>
              <div class="Nostars" v-else>No Review Yet</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 商品列表页 -->
      <div class="listTitle">Recommended Products</div>
      <div class="listBox" v-for="(item, index) in productList" :key="index">
        <div class="listBoxTitle">
          <span>{{ item.categoryName }} </span>
          <span class="descrText" v-if="item.descr"> ({{ item.descr }})</span>
        </div>
        <div class="listScroll">
          <div
            class="listItem"
            v-for="item2 in item.productEntityList"
            :key="item2.productId"
            @click="toProduct(item2)"
          >
            <div class="imgBox2">
              <VanImage
                :src="toPicProductImg(item2.productFileEntity.mainImg)"
                lazy-load
              />
              <!-- <img :src= toPicProductImg(item2.productFileEntity.mainImg)   alt=""> -->
            </div>
            <div class="listText">
              <div class="title ellipsis">{{ item2.productName }}</div>
              <!-- <div>Coverage : <span>123</span></div> -->
              <div v-if="item2.avgStar" class="Nostars">
                <Rate allow-half readonly v-model="item2.avgStar" :size="20" />
              </div>
              <div class="Nostars" v-else>No Review Yet</div>
              <div class="Fxafter">
                <span class="discountPrice">${{ item2.discountPrice }}</span>
                <span class="nomalPrice">
                  ${{ item2.nomalPrice }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <van-dialog
      v-model="show"
      title="Get Email Address"
      show-cancel-button
      width="90%"
      @confirm="confirm"
      :before-close="onBeforeClose"
      confirm-button-text="Confirm"
      cancel-button-text="Cancel"
    >
      <div>
        <div>
          <Field
            v-model.trim="userEmail"
            placeholder="Please fill in the collection email"
            clearable
            :error-message="userEmailMsg"
          />
        </div>
        <!-- <div class="Emailtext" >
          * Your personal data will not be shared with any third-party companies.
        </div> -->
      </div>
    </van-dialog>
  </div>
</template>
<script>
import request from "../../api/request";
import { toPicProductImg,toTime } from "../../utils/common";
import { removeStore, getStore, setStore } from "../../utils/storage";
import { setCookie, delCookie } from "../../utils/cookies";
import moment from 'moment'
export default {
  data() {
    return {
      endTime:null,
      discount: null,
      userEmail: "",
      title: "首页",
      statusCode: false, //验证码是否过期
      value: 2, //评分
      show: false,
      codes: JSON.parse(getStore("codes")) || false, //优惠券是不是领过
      productEntity: null, //分享的商品详情
      productList: [], //集合所有推荐列表类别
      // userId:JSON.parse(localStorage.getItem('user'))?JSON.parse(localStorage.getItem('user')).id :null,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [
        {islog:0, text: "Log in", icon: "https://b.yzcdn.cn/vant/icon-demo-1126.png" },
        {islog:1, text: "Log out", icon: "orders-o" },
        {islog:2, text: "Cat", icon: "cart-o" }
      ],
      isLogin: getStore("user")
    };
  },
  computed: {
    userEmailMsg() {
      if (this.userEmail === "") {
        return "please input your email";
      } else if (
        !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
          this.userEmail
        )
      ) {
        return "Email code format error";
      } else {
        return true;
      }
    }
  },
  created() {
    let urls = window.location.href ; //获取url中"?"符后的字串       
    let httpData = urls.split('?')[1]; 
    setStore('shareHttp',httpData)
    setStore('recomCustomerId',this.$route.query.userId)   //推荐人id
    this.ClickCount()  // 点击数
    // console.log(getStore("shareHttp"))
    if(this.codes){
      this.discount = this.codes.data.discount
      this.endTime = moment(new Date(this.codes.data.endTime)).format('MM/DD/YYYY')
      this.IsCodeStatus() //校验优惠券是否在有效期内
    }else{
      this.getDiscount();
    }
    this.getproduct();
    this.$nextTick(() => {
      if (this.isLogin) {
        this.actions.splice(0, 1);
      } else {
        this.actions.splice(1, 2);
      }
      
    });
  },
  methods: {
    toTime,
    toPicProductImg,
    getDiscount(){
      request("get", "cms/product/getDiscount").then(res => {
        if (res.code === 200) {
          this.discount = res.data.discount;
        }
      });
    },
    ClickCount(){
      let data = {
        recomCustomerId:this.$route.query.userId
      }
      request("put", "cms/linkordernum/updateClickCount", data).then(res => {
        if(res.code === 200) { }  // 进入页面给点击数
      })
    },
    getproduct() {//查询单个商品及相关推荐列表   分享单品调用
      // productId:"SXurgWY8nRoS"
      // 获取折扣
      if (this.$route.query.productId) {
        //分享来的
        let data = {
          productId: this.$route.query.productId,
          page: 1,
          limit: 10
        };
        request("get", "cms/product/queryAssignProOrDetail", data).then(res => {
          if (res.code === 200) {
            this.productEntity = res.data;
          }
        });
        // 查询所有推荐列表   分享全部调用  改变状态展示
        request("get", "cms/category/queryPageByRecomProAll").then(res => {
          if (res.code === 200) {
            this.productList = res.data.list;
            console.log("推荐列表", this.productList);
          }
        });
      } else {
        //非分享
        // 查询所有推荐列表   分享全部调用  改变状态展示
        request("get", "cms/category/queryPageByRecomProAll").then(res => {
          if (res.code === 200) {
            this.productEntity = res.productEntity;
            this.productList = res.data.list;
          }
        });
      }
    },
    toProduct(i) {
      this.$router.push({ path: "/productItem", query: { id: i.productId } });
    },
    Copys(){
      //创建一个input框
      let e = this.codes.data.couponCode 
      const input = document.createElement("input");
      //将指定的DOM节点添加到body的末尾
      document.body.appendChild(input);
      //设置input框的value值为直播地址
      input.setAttribute("value", e);
      //选取文本域中的内容
      input.select();
      //copy的意思是拷贝当前选中内容到剪贴板
      //document.execCommand（）方法操纵可编辑内容区域的元素
      //返回值为一个Boolean，如果是 false 则表示操作不被支持或未被启用
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      //删除这个节点
      document.body.removeChild(input);
      this.$toast.success("Copy successfully");
    },
    getYHJ(flag) {
      //获取优惠券
      this.show = true;
    },
    onSelect(action) {
      if (action.islog == 0) {
        this.$router.push("/login");
      }else if(action.islog == 1){
        removeStore("codes");
        removeStore("user");
        removeStore("Address");
        // delCookie("token");
        setCookie('token','')
        location.reload();
      }else if(action.islog == 2){
        this.$router.push("/cat");
      }
      // this.$toast(action.text);
    },
    onBeforeClose(action, done) {
      if (action == "confirm") {
        return done(false); //阻止关闭弹窗
      } else if (action == "cancel") {
        // this.userEmail = ''
        return done();
      }
    },
    IsCodeStatus(){   //校验优惠券是否在有效期内
      let data = {
        code :this.codes.data.couponCode
      }
      request("get", "cms/couponuser/checkCode", data).then(res => {
        if (res.code === 200) {
        } else {
          // let text = res.code =='150002' ? 'expired' : res.msg
          // Notify({ type: "danger", message: text });
          this.statusCode = true;
        }
      });
    },
    getReceiveCoupon() {
      //领取优惠券JSON.parse(this.$store.state.user).id
      let data = {
        userEmail : this.userEmail,
        // userEmail: "liangyingjie615@gmail.com",
        userId :this.$route.query.userId,  //  用户id
        // userId: "SEhs4gjeJO04" //推荐人ID
      };
      let url;
      if (this.statusCode) {
        url = "cms/coupon/againReceiveCoupon"; //重新领取优惠券
      } else {
        url = "cms/coupon/receiveCoupon"; //常规领取
      }
      request("get", url, data).then(res => {
        if (res.code === 200) {
          console.log('请求到的code' , res)  
          setStore("codes", res); 
          this.codes = res;
          let statusCode = res.data.statusCode;
          if (statusCode == "2") {//  优惠券判断是否过期   0：未使用， 1：已使用  ， 2已过期
            // 验证码已过期
            this.statusCode = true; //过期开关
          } else {
            this.statusCode = false;
            this.discount = res.data.discount;
            this.endTime = moment(new Date(res.data.endTime)).format('MM/DD/YYYY')
            this.$toast.success("The coupon code has been sent to your email.");
          }
        }
      });
    },
    confirm() {
      if (this.userEmailMsg == true) {
        console.log(666, this.userEmailMsg);
        this.getReceiveCoupon();
        this.show = false;
        this.userEmail = "";
      }
    },
    getUserInfo(event) {
      console.log(event.detail);
    },

    onClose() {
      // this.setData({ show: false });
      this.show = false;
    },
    changelogin() {},
    passwordErr() {}
  }
};
</script>
<style lang="less" scoped>
.REFERRAL {
  text-align: center;
  .top {
    width: 100%;
    display: flex;
    flex-flow: column;
    background: url("../../../public/img/REFERRALbg.png") no-repeat;
    .FXdetail{
      margin:0 10px 20px 10px;
    }
    .topItem {
      margin-bottom: 30px;
      color: #fff;
      .copys {
        font-size: 13px;
        color: #e6e4ff;
        margin-left: 20px;
        border-bottom: 1px #e6e4ff solid;
      }
      .btn {
        width: 250px;
        font-weight: bold;
        color: #4181ff;
        font-size: 18px;
        border-radius: 20px;
        height: 40px;
        line-height: 40px;
      }
      .copybtn{
        color:#090A0E !important;
        .copyBtnText{
          color:#4181FF;
          font-weight: normal;
          padding-left: 20px;
        }
      }
      .yzmaa{
        background: #fff;
      }
      .yzmbb{
        background: url("../../../public/img/codeImg2.png") no-repeat,50px,0;
        background-size:250px 53px;
        background-position: 0 0;
      }
    }
    .Fxafter {
      padding-top: 5px;
      font-size: 15px;
      color: #e6e4ff;
    }
    .topOne {
      text-align: left;
      color:#3E4ECA;
      padding:5px 0 0 102px ;
      margin-top: 20px;
      font-size: 50px;
      font-weight: bold;
      height: 165px;
      background: url("../../../public/img/codeImg.png") no-repeat,50px,0;
      background-size:220px 165px;
      background-position: 88px -15px;
      span {
        font-size: 17px;
      }
    }
    .topFont {
      font-size: 17px;
      margin-bottom: 20px;
      // color:#E6E4FF
    }
    .fxXX {
      display: flex;
      padding: 10px;
      background: #fff;
      font-size: 12px;
      color: #9ba1aa;
      .imgBox {
        width: 129px;
        height: 129px;
        img {
          width: 129px;
          max-height: 100%;
        }
      }
      .fxXXR {
        text-align: left;
        padding: 0 10px;
        min-width: 120px;
        .basic{
          // word-wrap:break-word;
          line-height: 18px;
           /* 在恰当的断字点进行换行 */
          word-break: break-all;
          /* 超出范围隐藏 */
          overflow: hidden;
          /* 文字超出用省略号 */
          text-overflow: ellipsis;
          /* 盒子模型 */
          display: -webkit-box;
          /* 显示的文本行数 */
          -webkit-line-clamp: 3;
          /* 子元素的垂直排列方式 */
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  .listTitle {
    font-size: 17px;
    // font-weight: bold;
    padding: 20px 0;
    color: #4181ff;
  }
  .listBox {
    overflow: hidden;
    .listBoxTitle {
      font-size: 15px;
      font-weight: bold;
      padding: 0 0 10px 10px;
      text-align: left;
      .descrText{
        font-weight: normal;
      }
    }
    .listScroll {
      width: 100%;
      display: flex;
      overflow: scroll;
      margin-bottom: 20px;
    }
    .listItem {
      text-align: left;
      margin-left: 10px;
      padding-bottom: 10px;
      width: 144px;
      border: 1px #D1D4D9 solid;
      .imgBox2 .van-image {
        width: 144px;
        height: 144px;
        img {
          width: 100%;
          max-height: 100%;
        }
      }
      .listText {
        padding-left: 5px;
      }
    }
  }
  .Emailtext{
    padding-bottom: 10px;
    font-size: 14px;
  }
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #090A0E;
    word-break: normal;
  }
}
</style>
<style>
.REFERRAL .van-button--hairline::after{
  border:none
}
</style>
